import * as React from 'react';
import {PartnerBrandVehiclesImportResult} from "../../../model/importVehicles/PartnerBrandVehiclesImportResult";

interface ComponentProps {
	result: PartnerBrandVehiclesImportResult;
}

const PartnerBrandVehiclesImportResultsTile: React.SFC<ComponentProps> = ({result}) => {
	return (
		<div style={{
			padding: '20px',
			textAlign: 'center',
			backgroundColor: 'rgba(17, 35, 99, 0.05)',
			borderRadius: '8px',
			margin: '10px 0'
		}}>
			<p style={{margin: '8px 0'}}>Total vehicles processed: <strong>{result.totalCount}</strong></p>
			<p style={{margin: '8px 0'}}>Successfully added: <strong>{result.successNewCount}</strong></p>
			<p style={{margin: '8px 0'}}>Updated existing: <strong>{result.successExistingCount}</strong></p>
			<p style={{margin: '8px 0'}}>Invalid registration: <strong>{result.invalidRegistrationCount}</strong></p>
		</div>
	);
};

export default PartnerBrandVehiclesImportResultsTile;
